let cache = null;
const norm = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, "");

export const loadCities = () => {
  if (!cache) cache = import("./canadaCities.json").then((m) => (m.default || m).map(([city, province]) => ({ city, province, key: norm(city) })));
  return cache;
};

export async function searchCities(q, province, limit = 8) {
  const needle = norm(q || "");
  if (needle.length < 2) return [];
  const all = await loadCities();
  const starts = [], contains = [];
  for (const c of all) {
    if (c.key.startsWith(needle)) starts.push(c);
    else if (needle.length >= 3 && c.key.includes(needle)) contains.push(c);
  }
  const rank = (list) => (province ? [...list.filter((c) => c.province === province), ...list.filter((c) => c.province !== province)] : list);
  return [...rank(starts), ...rank(contains)].slice(0, limit);
}

export const formatLocation = (city, province) => [city.trim(), province].filter(Boolean).join(", ");
